import React, { useState, useRef, useEffect } from "react";
import axios from "axios";

import { sendFromCountries, sendToCountries } from "../utils/countries";
import SendMoneySelectionInput from "./SendMoneySelectionInput";
import RateCalculator from "./RateCalculator";

import { exchange } from "../utils/exchangeRate";

const defaultCountries = {
  sendFrom: sendFromCountries,
  sendTo: sendToCountries,
};

function CurrencySelection(props) {
  const sendFromInput = useRef(null);
  const sendToInput = useRef(null);
  const sendToServices = useRef(null);

  const [sendFromCountry, setSendFromCountry] = useState([]);
  const [sendToCountry, setSendToCountry] = useState([]);
  const [availableServices, setAvailableServices] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [amount, setAmount] = useState({ total: 1, currency: "GBP" });

  const [exchangeRates, setExchangeRates] = useState(exchange);

  const getSelectedCountry = (title, selectedCountry) => {
    if (title === "Send From") {
      setSendFromCountry(selectedCountry);
    }
    if (title === "Send To") {
      setSendToCountry(selectedCountry);
      setAvailableServices(selectedCountry[0].services);
      setSelectedService("Select...");
    }
  };

  const handleChange = (e) => {
    setAmount({ ...amount, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const exchageRate = async () => {
      const response = await axios.get(
        `https://openexchangerates.org/api/latest.json?app_id=14b8b1d712474322bfa1883c72f92025`
      );
      if (response) {
        const { data } = response;
        setExchangeRates(data.rates);
      }
    };

    exchageRate();
  }, []);

  return (
    <>
      <div className="d-flex flex-column flex-lg-row">
        <SendMoneySelectionInput
          title="Send From"
          availableCountries={defaultCountries.sendFrom}
          inputFieldRef={sendFromInput}
          getSelectedCountry={getSelectedCountry}
        />
        <SendMoneySelectionInput
          title="Send To"
          availableCountries={defaultCountries.sendTo}
          inputFieldRef={sendToInput}
          getSelectedCountry={getSelectedCountry}
        />
      </div>
      {sendToCountry.length > 0 && (
        <div className="d-flex flex-column flex-lg-row mt-3">
          <SendMoneySelectionInput
            availableServices={availableServices}
            inputFieldRef={sendToServices}
            setSelectedService={setSelectedService}
            selectedService={selectedService}
          />
          <div style={{ flexBasis: "100%" }}>
            <h2></h2>
            <div className="position-relative rounded-pill bg-white mx-2 px-2 py-2 d-flex align-item-center justify-content-between mb-3">
              <input
                type="number"
                placeholder="1"
                name="total"
                onChange={handleChange}
                className="border-0 border-end border-gray97 bg-transparent outline-none d-block"
              />
              <select
                className="w-100 form-select-sm border-0 outline-none boxshadow-none py-0 bg-white"
                onChange={handleChange}
                name="currency"
                aria-label="Default select example"
              >
                {sendToCountry[0].currency.map((cur) => (
                  <option key={cur} value={cur}>
                    {cur}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      )}
      {sendToCountry.length > 0 && selectedService !== "Select..." && (
        <RateCalculator
          exchange={exchangeRates}
          amount={amount}
          sendToCountry={sendToCountry}
          sendFromCountry={sendFromCountry}
        />
      )}
    </>
  );
}

export default CurrencySelection;
